export const iconFontAwesomeMapsSquarePlus = (
	<i className="fa-solid fa-square-plus"></i>
);
